import Navigation from './components/navigation';
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

// if there is a param to hide the navigation, the navi should be visible with
// hovering the top of the page with the mouse.
// therefore an event listener is attached to the document, checking the
// mouse area and showing the navigation in the 56 pixels the navigation would be.
// to hide the navigation again a scoll event listener is attached. on scrolling
// an opened navigation will hide again.
// on mobile we have no mouse. so we show the navigation when scrolling up in
// the direction back to top and hide the navigation when scrolling down in
// the direction of the footer.
function hiddenNaviInit() {
  const isMobile = document.body.clientWidth < 800,
        $headerNavigation = $('body > header');

  function showDesktopNavigation(e) {
    if (e.clientY < 56) {
      $headerNavigation.stop().fadeIn(200);
      document.removeEventListener('mousemove', showDesktopNavigation);
      window.addEventListener('scroll', hideDesktopNavigation);
    }
  }

  function hideDesktopNavigation() {
    $headerNavigation.stop().fadeOut(200);
    window.removeEventListener('scroll', hideDesktopNavigation);
    document.addEventListener('mousemove', showDesktopNavigation);
  }

  function showMobileNavigation() {
    $headerNavigation.stop().fadeIn(100);
  }

  function hideMobileNavigation() {
    $headerNavigation.stop().fadeOut(100);
  }

  // add event listener only, if the navi is hidden on page load
  if ($headerNavigation.length && $headerNavigation.hasClass('hidenav')) {
    if (isMobile) {
      // on mobile register touch events for showing/hiding the navi
      // inspired by https://stackoverflow.com/a/22290641 & https://stackoverflow.com/a/24220422
      let touchStartPosition = 0;

      $(document).bind('touchstart', (e) => {
        touchStartPosition = e.originalEvent.touches[0].clientY;
      });

      $(document).bind('touchmove', (e) => {
        const touchMovePosition = e.originalEvent.changedTouches[0].clientY,
              offset = 5;

        if (Math.abs(touchStartPosition - touchMovePosition) > offset) {
          if (touchStartPosition > touchMovePosition) {
            hideMobileNavigation();
          } else {
            showMobileNavigation();
          }
          touchStartPosition = touchMovePosition;
        }
      });
    } else {
      document.addEventListener('mousemove', showDesktopNavigation);
    }
  }
}

function navigationInit() {
  ReactDOM.render(<Navigation />, $('.navigation')[0]);

  hiddenNaviInit();
}

export { navigationInit };



// WEBPACK FOOTER //
// ./navigationInit.js